export const formatDate = new Intl.DateTimeFormat('pt-BR').format
